const declineMessages = {
  insufficient_funds: "This card has insufficient funds.",
  expired_card: "This card has expired.",
  incorrect_cvc: "The card's security code is incorrect.",
  generic_decline:
    "The bank declined this payment without providing a specific reason.",
};

const declineNextStep = "Try a different card or cancel the payment.";

export const getPaymentErrorMessage = (error, options = {}) => {
  const {
    staff = false,
    quickPay = false,
    fallback = "Payment failed. Please try again or use a different card.",
    networkMessage = "Could not connect. Please check your connection and try again.",
  } = options;
  const response = error?.response;
  const data = response?.data || {};
  const serverMessage = [
    data.failure_message,
    data.message,
    typeof data.error === "string" ? data.error : data.error?.message,
    Array.isArray(data.errors) ? data.errors.join(", ") : data.errors,
  ].find((message) => typeof message === "string" && message.trim());

  if (data.error_type === "card_error" || response?.status === 402) {
    if (
      Object.prototype.hasOwnProperty.call(declineMessages, data.decline_code)
    ) {
      return quickPay
        ? declineMessages[data.decline_code]
        : `${declineMessages[data.decline_code]} ${declineNextStep}`;
    }
    if (["lost_card", "stolen_card"].includes(data.decline_code)) {
      if (quickPay) return "This card was declined.";
      const bankAdvice = staff
        ? "This card was declined. Have the cardholder contact their bank."
        : "This card was declined. Please contact your bank.";
      return `${bankAdvice} ${declineNextStep}`;
    }
    if (data.decline_code === "generic_decline") {
      if (quickPay) return declineMessages.generic_decline;
      const bankAdvice = staff
        ? "Have the cardholder contact their bank."
        : "Contact your bank.";
      return `${declineMessages.generic_decline} ${declineNextStep} ${bankAdvice}`;
    }
    const cardErrorMessage =
      serverMessage ||
      (staff
        ? "This card was declined. Have the cardholder contact their bank."
        : "This card was declined. Please contact your bank.");
    return quickPay
      ? cardErrorMessage
      : `${cardErrorMessage} ${declineNextStep}`;
  }
  if (data.error_type === "invalid_request") {
    return "There was a problem processing your payment. Please try again.";
  }
  if (data.error_type === "stripe_unavailable") {
    return "Payment service is temporarily unavailable. Please try again shortly.";
  }
  if (!response) return networkMessage;
  return serverMessage || fallback;
};
